import { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { InputAdornment, CircularProgress } from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import { FormGroup, TextField, FormButtons, Button } from '../common';
import { validateEmail } from '../../utils/functions';
import { useSnackbar } from 'notistack';
import cn from 'classnames';
import { COLORS } from '../../theme/variables';

export interface SumbitAttendanceForm {
  value: string;
  onCancel: () => any;
}

interface Props {
  loading?: boolean;
  onSuccess: (params: SumbitAttendanceForm) => any;
  onCancel: () => any;
}

const useStyles = makeStyles((theme) => ({
  formButtons: {
    alignItems: 'flex-end',
    flexGrow: 1
  },
  error: {
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: COLORS.COLOR_RED_BASE
    }
  }
}));

function GatheringAttendance({ loading = false, onSuccess, onCancel }: Props) {
  const classes = useStyles();
  const [searchValue, setSearchValue] = useState('');
  const { enqueueSnackbar } = useSnackbar();
  const [error, setError] = useState(false);

  const checkValidGuestEmail = (value: string) => {
    let validEmail = true;
    if (!validateEmail(value)) {
      enqueueSnackbar('This email is not valid', {
        variant: 'error'
      });

      validEmail = false;
    }
    setError(!validEmail);
    return validEmail;
  };

  const handleGuestAdd = (value: string) => {
    if (!checkValidGuestEmail(value)) {
      return false;
    }

    onSuccess({ value, onCancel });
  };

  return (
    <>
      <FormGroup>
        <TextField
          value={searchValue}
          className={cn({ [classes.error]: error })}
          label='Add attendance'
          placeholder='Enter email'
          onChange={(e) => {
            if (error) {
              setError(false);
            }
            setSearchValue(e.target.value);
          }}
          InputProps={{
            startAdornment: (
              <InputAdornment position='start'>
                <SearchIcon />
              </InputAdornment>
            )
          }}
        />
      </FormGroup>

      <FormButtons className={classes.formButtons}>
        <Button onClick={onCancel} variant='outlined'>
          Cancel
        </Button>
        <Button
          onClick={() => handleGuestAdd(searchValue)}
          disabled={loading || error || !searchValue}
          data-testid='button-apply'>
          {loading ? <CircularProgress size={24} color='inherit' /> : 'Apply'}
        </Button>
      </FormButtons>
    </>
  );
}

export default GatheringAttendance;
